module.exports = __webpack_public_path__ + "img/kg.1c92e07a.png";